import { render, staticRenderFns } from "./StoreProductTabReadOnly.vue?vue&type=template&id=42e0e18b&"
import script from "./StoreProductTabReadOnly.vue?vue&type=script&lang=js&"
export * from "./StoreProductTabReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports